import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PosPurchaseService {


	constructor(private http: HttpClient) { }

	url = environment.serverAPI5 + '/' + 'api/pospurchases';

	url1 = environment.serverAPI5 + '/' + 'api/purimport';

	url2 = environment.serverAPI5 + '/' + 'api/purchases';

	url3 = environment.serverAPI5 + '/' + 'api/pospurchases';

	searchPurchase(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getPurchase(Page: number, size: number, sort: any): Observable<Object> {
		return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
	}

	getPurchaseById(id: number): Observable<Object> {
		return this.http.get(`${this.url}/${id}`);
	}
	deleteByPurchaseId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}


	createPurchase(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, Purchase);
	}
	deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}
	downloadPurchaseTemplate(): Observable<any> {
		return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}
	downloadPurchaseReport(Page: number, size: number, sort, selectionPurchase): Observable<any> {
		return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionPurchase, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}


	searchPurchasesReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

		const requestBody = {
			"searchQuery": query != null ? query.split("'").join('') : null,

		};

		const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

		return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
	}

	updatePurchaseExcel(purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url3}/bulk/import`, purchase);
	}

	savePurchaseColumnMap(Purchase: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url1}/new`, Purchase);
	}

	getBySupplierIdColumnMap(id: any): Observable<Object> {
		return this.http.get(`${this.url1}/colMap/${id}`);
	}

}
